export const ExternalLinkIcon = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#B2ABAB"
    strokeWidth={1.9}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 5h5v5" />
    <path d="M19 5l-8 8" />
    <path d="M19 13v6H5V5h6" />
  </svg>
);
